import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import { useState, useRef, useEffect } from 'react';

function OrderDetail({ orderDate }) {
  const toastGridDivRef = useRef(null);
  const [date, setDate] = useState({ start: GetDate(7), end: GetDate(0) });
  const [isAllInquiry, setIsAllInquiry] = useState(false);

  function GetDate(minusDay) {
    const now = new Date();
    now.setDate(now.getDate() - minusDay);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); //월은 0부터 시작하므로 +1
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const apiUrl = process.env.REACT_APP_API_DOMAIN + `dkm/order-detail`;
  const dataSource = {
    api: {
      readData: { url: apiUrl, method: 'GET', initParams: { } }
    },
    initialRequest: false,
  };

  const columnArray = [
    { name: 'order_no', header: '주문번호', align: 'center', width: 'auto', resizable: true, sortable: true },
    { name: 'order_status', header: '현황', align: 'center', width: 'auto', resizable: true, filter: { type: 'select', option: []} },
    { name: 'cust_nm', header: '업체명', align: 'center', width: 'auto', resizable: true, filter: { type: 'select', option: []}, renderer: { styles: { color: (props) => gridReference.current.getInstance().getValue(props.rowKey, 'overdue_days') > 0 ? 'red' : 'black', fontWeight: (props) => gridReference.current.getInstance().getValue(props.rowKey, 'overdue_days') > 0 ? 'bold' : 'normal' } } },
    { name: 'item_nm', header: '모델명', align: 'center', width: 'auto', resizable: true, filter: { type: 'select', option: []}, renderer: { styles: { color: (props) => gridReference.current.getInstance().getValue(props.rowKey, 'overdue_days') > 0 ? 'red' : 'black', fontWeight: (props) => gridReference.current.getInstance().getValue(props.rowKey, 'overdue_days') > 0 ? 'bold' : 'normal' } } },
    { name: 'qty', header: '수량', align: 'center', width: 'auto', resizable: true, sortable: true },
    { name: 'order_dt', header: '주문일자', align: 'center', width: 'auto', resizable: true, sortable: true },
    { name: 'due_dt', header: '납기요청일', align: 'center', width: 'auto', resizable: true, sortable: true },
    { name: 'end_dt', header: '완료예정일', align: 'center', width: 'auto', resizable: true, sortable: true },
    { name: 'overdue_days', header: '납품초과일', align: 'center', width: 'auto', resizable: true, sortable: true }
  ];
  const gridReference = useRef(); // 그리드 참조
  const [grid, setGrid] = useState(
    <Grid
      ref={gridReference} //그리드 참조
      width={'100%'}
      bodyHeight={0}
      data={dataSource}
      columns={columnArray}
      rowHeaders={['rowNum']}
      onResponse={OnResponse} //서버 응답
      onGridUpdated={OnGridUpdated}
    />
  );

  useEffect(() => {
    setIsAllInquiry(orderDate === undefined);

    const params = {};
    if (orderDate === undefined) {
      params.startDate = date.start;
      params.endDate = date.end;
    } else {
      params.orderDate = orderDate;
    }

    gridReference.current.getInstance().readData(1, params, true);
  }, []);

  function OnGridUpdated(event) {
    let allColumnWidth = 0;
    const tempColumnArray = [...columnArray];
    const columns = gridReference.current.getInstance().getColumns();
    for (const index1 in columns) {
      for (const index2 in tempColumnArray) {
        if (tempColumnArray[index2].name === columns[index1].name) {
          if (columns[index1].autoResizing === true) {
            //컬럼 사이즈가 오토로 지정됐다면 width에 + 15하여 셀 내용 잘림 방지(sort, filter로 인한 컬럼 폭)
            tempColumnArray[index2].width = columns[index1].baseWidth + 15;
          }
          
          //그리드의 width를 정하기 위해 총 컬럼 width를 구함
          allColumnWidth += tempColumnArray[index2].width;
        }
      }
    }
    
    const gridWidth = toastGridDivRef.current.offsetWidth - 57;

    if (gridWidth > allColumnWidth) {
      for (const column of tempColumnArray) {
        column.width += (gridWidth - allColumnWidth) / tempColumnArray.length;
      }
    }
    
    event.instance.setColumns(tempColumnArray);
    
    event.instance.setBodyHeight(toastGridDivRef.current.offsetHeight - 42);

    /*setPopupStyle((previousState) => {
      const previousStyle = {...previousState};
      
      const height = gridReference.current.getInstance().getRowCount() * 40 + 104;
      const maxHeight = window.innerHeight * 0.8;
      const minHeight = 217;
      if (height >= maxHeight) {
        previousStyle.content.height = maxHeight;
      } else if (height >= minHeight) {
        previousStyle.content.height = height;
      } else {
        previousStyle.content.height = minHeight;
      }
      
      //그리드 height 적용, 두 코드 모두 사용 가능
      event.instance.setBodyHeight(previousStyle.content.height - (87));
      //event.instance.setHeight(previousStyle.content.height - (46));

      const width = allColumnWidth + 61;
      const maxWidth = window.innerWidth * 0.9;
      if (width >= maxWidth) {
        previousStyle.content.width = maxWidth;
      } else {
        previousStyle.content.width = width;  
      }

      previousStyle.content.width = '100vw';
      previousStyle.content.height = '100vh';

      return previousStyle;
    });*/
  }

  function OnResponse(event) {
    const response = JSON.parse(event.xhr.response);

    if (!response.result) {
      alert(`(${response.apiUrl}) ${response.apiMethod} API 실패\n${response.message}`);
    }
  }

  function DateOnChange(event) {
    setDate((previous) => {
      if (event.target.id === 'start') {
        return { ...previous, start: event.target.value };
      } else if (event.target.id === 'end') {
        return { ...previous, end: event.target.value };
      }
    });
  }

  function Inquiry() {
    const params = {};
    if (isAllInquiry) {
      params.startDate = date.start;
      params.endDate = date.end;
    } else {
      params.orderDate = orderDate;
    }

    gridReference.current.getInstance().readData(1, params, true);
  }

  return (
    <div style={{ width: '100%', height: `calc(100% - 45px)` }}>
      {isAllInquiry && <div style={{ height: 40, display: 'flex', alignItems: 'center', gap: 10 }}>
        <label style={{ marginLeft: 20 }}>조회 기간</label>
        <input type='date' id='start' value={date.start} onChange={DateOnChange} style={{ borderRadius: 5, fontFamily: 'Arial, sans-serif', width: 90, height: 25, lineHeight: 1 }}/>
        <label>~</label>
        <input type='date' id='end' value={date.end} onChange={DateOnChange} style={{ borderRadius: 5, fontFamily: 'Arial, sans-serif', width: 90, height: 25, lineHeight: 1 }}/>
        <button onClick={Inquiry}>조회</button>
      </div>}

      <div ref={toastGridDivRef} style={{ width: '100%', height: `calc(100% - ${isAllInquiry ? 40 : 0}px)` }}>
        {grid}
      </div>
    </div>
  );
}

export default OrderDetail;